import { render, staticRenderFns } from "./list_cqjy.vue?vue&type=template&id=fbb2d4de&scoped=true"
import script from "./list_cqjy.vue?vue&type=script&lang=js"
export * from "./list_cqjy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb2d4de",
  null
  
)

export default component.exports